import { BehaviorSubject } from 'rxjs';


/**
 * A BehaviorSubject type alias for services that don't allow changing the external changes to the contained value.
 */
export type ReadonlyBehaviorSubject<T> = Omit<BehaviorSubject<T>, 'next'>;
